export const features = {
    startDates: process.env.NEXT_PUBLIC_FEATURE_START_DATES,
    groups: process.env.NEXT_PUBLIC_FEATURE_GROUPS,
    preferences: process.env.NEXT_PUBLIC_FEATURE_PREFERENCES,
    feature30Day: process.env.NEXT_PUBLIC_FEATURE_30DAY,
    datadog: process.env.NEXT_PUBLIC_FEATURE_DATA_DOG,
    myStuffLanes: process.env.NEXT_PUBLIC_FEATURE_MY_STUFF_LANE,
    profilePage: process.env.NEXT_PUBLIC_FEATURE_PROFILE_PAGE
}
export const hasFeature = (featureName, user) => {
    let has = false
    const cyf = user?.stripeSubscriptionId && user?.stripeSubscriptionId !== null
    if (user !== null && user !== null && user?.isAuthenticated && user?.email) {
        if (features[featureName]?.indexOf(',') >= 0) {
            const options = features[featureName].split(',')
            has = options.indexOf(user.email.toLowerCase()) >= 0
            if (!has && user.isAdmin) {
                has = options.indexOf('admin') >= 0
            }
            if (!has && cyf === true) {
                has = options.indexOf('cyf') >= 0
            }
        } else if (features[featureName] === user.email) {
            has = true
        } else {
            has =
                features[featureName] === 'true' ||
                (user.isAdmin && features[featureName] === 'admin') ||
                (cyf && features[featureName] === 'cyf')
        }
    } else {
        has = features[featureName] === 'true'
    }
    return has
}
